export default __webpack_public_path__ + "static/O0108-0857fb9d5ee3a354df6397ac8e8426de.png";